import React from 'react';
import LessonMarkdown from './lecke/LessonMarkdown';
import { isMarkdown } from '../lib/leckeMarkdown';

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

function renderLineWithLinks(line, keyPrefix) {
  const parts = line.split(URL_REGEX);
  return parts.map((part, i) => {
    if (part.match(URL_REGEX)) {
      return (
        <a
          key={`${keyPrefix}-${i}`}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#00D2C8',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            wordBreak: 'break-all',
          }}
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={`${keyPrefix}-${i}`}>{part}</React.Fragment>;
  });
}

/* A markdown-leírás (Tananyag 1. kör: `##` címsor vagy kép van benne) a LessonMarkdown-nal; a régi,
   sima szöveges leírás (✓-os sorok, linkek) az alábbi régi úton, változatlanul. */
export default function LessonDescription({ text }) {
  if (!text) return null;
  if (isMarkdown(text)) return <LessonMarkdown text={text} />;

  const paragraphs = text.trim().split(/\n\s*\n/);

  return (
    <div style={{ fontSize: 15, lineHeight: 1.7, color: 'rgba(255,255,255,0.85)' }}>
      {paragraphs.map((para, pIdx) => {
        const lines = para.split('\n').filter(l => l.trim() !== '');
        const isBulletBlock = lines.length > 1 && lines.every(l => l.trim().startsWith('✓'));

        if (isBulletBlock) {
          return (
            <ul key={pIdx} style={{ listStyle: 'none', padding: 0, margin: '0 0 16px 0' }}>
              {lines.map((line, lIdx) => (
                <li key={lIdx} style={{ marginBottom: 6, paddingLeft: 4 }}>
                  {renderLineWithLinks(line.trim(), `${pIdx}-${lIdx}`)}
                </li>
              ))}
            </ul>
          );
        }

        return (
          <p key={pIdx} style={{ margin: '0 0 16px 0' }}>
            {lines.map((line, lIdx) => (
              <React.Fragment key={lIdx}>
                {renderLineWithLinks(line, `${pIdx}-${lIdx}`)}
                {lIdx < lines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
